import { PropertyGroup } from "../property-group";
import { powerStonesRemainingProperty } from "./power-stones-remaining-property";
import { cpProperty } from "./cp-property";

export const calculatedGroup = new PropertyGroup("Calculated", [cpProperty, powerStonesRemainingProperty])
